import { render, staticRenderFns } from "./OrderTransactions.vue?vue&type=template&id=35c9bdcb&scoped=true&"
import script from "./OrderTransactions.vue?vue&type=script&lang=js&"
export * from "./OrderTransactions.vue?vue&type=script&lang=js&"
import style0 from "./OrderTransactions.vue?vue&type=style&index=0&id=35c9bdcb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9bdcb",
  null
  
)

export default component.exports